// import React, { useState } from 'react';
// import { useEditor, EditorContent } from '@tiptap/react';
// import StarterKit from '@tiptap/starter-kit';
// import Image from '@tiptap/extension-image';
// import uploadImage from '../helper/uploadImage'; 
// import apiCall from '../helper/apiCall';
// import { 
//   FaBold, FaItalic, FaListUl, FaHeading, 
//   FaImage, FaSave, FaSpinner, FaUser, FaTag, FaGlobe 
// } from 'react-icons/fa';

// const MenuBar = ({ editor }) => {
//   const [isUploading, setIsUploading] = useState(false);

//   if (!editor) return null;

//   const handleFileChange = async (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     setIsUploading(true);
//     try {
//       const data = await uploadImage(file);
//       if (data?.secure_url) {
//         editor.chain().focus().setImage({ 
//           src: data.secure_url, 
//           alt: 'Authentic Kantha Stitch Detail - kanthasri.com' 
//         }).run();
//       }
//     } catch (error) {
//       alert("Image upload failed");
//     } finally {
//       setIsUploading(false);
//       event.target.value = '';
//     }
//   };

//   return (
//     <div className="flex flex-wrap gap-2 p-3 border-b border-slate-100 bg-slate-50 rounded-t-2xl">
//       <button 
//         type="button"
//         onClick={() => editor.chain().focus().toggleBold().run()}
//         className={`p-2 rounded ${editor.isActive('bold') ? 'bg-indigo-100 text-indigo-600' : 'hover:bg-slate-200'}`}
//       >
//         <FaBold title="Bold (SEO Keywords)" />
//       </button>
//       <button 
//         type="button"
//         onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
//         className={`p-2 rounded ${editor.isActive('heading', { level: 2 }) ? 'bg-indigo-100 text-indigo-600' : 'hover:bg-slate-200'}`}
//       >
//         <FaHeading title="H2 Heading" />
//       </button>
//       <button 
//         type="button"
//         onClick={() => editor.chain().focus().toggleBulletList().run()}
//         className={`p-2 rounded ${editor.isActive('bulletList') ? 'bg-indigo-100 text-indigo-600' : 'hover:bg-slate-200'}`}
//       >
//         <FaListUl title="List (Better Scannability)" />
//       </button>

//       <div className="w-[1px] h-6 bg-slate-300 mx-1 self-center" />

//       <label className="relative p-2 text-slate-600 hover:bg-slate-200 rounded cursor-pointer flex items-center gap-2">
//         {isUploading ? <FaSpinner className="animate-spin text-indigo-600" /> : <FaImage />}
//         <span className="text-xs font-bold">{isUploading ? 'Processing...' : 'Add Detail Image'}</span>
//         <input type="file" className="hidden" accept="image/*" disabled={isUploading} onChange={handleFileChange} />
//       </label>
//     </div>
//   );
// };

// const BlogEditor = () => {
//   const [title, setTitle] = useState('');
//   const [slug, setSlug] = useState('');
//   const [category, setCategory] = useState('Kantha Heritage');
//   const [metaDescription, setMetaDescription] = useState('');
//   const [featuredImage, setFeaturedImage] = useState('');
//   const [authorName, setAuthorName] = useState('Kanthasri Team');
//   const [isPublishing, setIsPublishing] = useState(false);

//   const editor = useEditor({
//     extensions: [
//       StarterKit,
//       Image.configure({
//         HTMLAttributes: { class: 'rounded-xl shadow-lg my-8 max-w-full border border-slate-100 mx-auto' },
//       }),
//     ],
//     content: '<h2>The Art of the Stitch</h2><p>Write about the Birbhum artisans here...</p>',
//     editorProps: {
//       attributes: { class: 'prose prose-stone focus:outline-none max-w-none min-h-[600px] p-10 bg-white' },
//     },
//   });

//   const handleTitleChange = (e) => {
//     const val = e.target.value;
//     setTitle(val);
//     setSlug(val.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, ''));
//   };

//   const handleFeaturedImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const data = await uploadImage(file);
//       setFeaturedImage(data.secure_url);
//     }
//   };

//   const publishBlog = async () => {
//     if (!title || !editor.getHTML()) return alert("Content is missing!");
    
//     setIsPublishing(true);
//     const blogData = {
//       title,
//       slug,
//       content: editor.getHTML(),
//       meta_description: metaDescription,
//       featured_image_url: featuredImage,
//       category,
//       author_name: authorName,
//       is_published: true
//     };

//     try {
//       // Using your helper: apiCall(endpoint_name, data)
//       const result = await apiCall('saveBlog', blogData);      
//       if (result.success) {
//         alert("Success! Your story is now live on kanthasri.com");
//       } else {
//         alert(result.message || "Failed to publish.");
//       }
//     } catch (error) {
//       console.error("API Error:", error);
//     } finally {
//       setIsPublishing(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-[#fcfaf7] p-4 md:p-8 font-sans">
//       {/* Kanthasri Branding Header */}
//       <div className="max-w-6xl mx-auto flex justify-between items-center mb-8 bg-white p-5 rounded-2xl shadow-sm border border-slate-100">
//         <div className="flex items-center gap-3">
//           <div className="bg-amber-900 p-2 rounded-lg text-white"><FaGlobe /></div>
//           <div>
//             <h2 className="text-xl font-bold text-slate-900 tracking-tight">kanthasri.com</h2>
//             <p className="text-[10px] text-amber-700 font-bold uppercase tracking-widest">Content Studio</p>
//           </div>
//         </div>
//         <button 
//           onClick={publishBlog}
//           disabled={isPublishing}
//           className="flex items-center gap-2 px-10 py-3 bg-amber-900 text-white font-bold rounded-xl hover:bg-black transition-all shadow-lg hover:shadow-amber-200 disabled:bg-slate-400"
//         >
//           {isPublishing ? <FaSpinner className="animate-spin" /> : <FaSave />} Publish to Web
//         </button>
//       </div>

//       <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-4 gap-8">
//         <div className="lg:col-span-3 space-y-6">
//           {/* Main Writing Area */}
//           <div className="bg-white rounded-3xl shadow-sm border border-slate-200 overflow-hidden">
//             <input 
//               type="text"
//               placeholder="Enter Blog Title..."
//               className="w-full text-4xl font-serif p-10 pb-4 outline-none border-none text-slate-900 placeholder:text-slate-200"
//               value={title}
//               onChange={handleTitleChange}
//             />
//             <MenuBar editor={editor} />
//             <EditorContent editor={editor} />
//           </div>
//         </div>

//         {/* Sidebar: SEO & Metadata */}
//         <aside className="space-y-6">
//           <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
//             <h3 className="text-xs font-black text-slate-400 uppercase tracking-widest mb-4 flex items-center gap-2">
//               <span className="w-2 h-2 bg-green-500 rounded-full"></span> SEO Engine
//             </h3>
            
//             <label className="block text-[10px] font-bold text-slate-500 uppercase mb-2">Google Search Snippet</label>
//             <textarea 
//               placeholder="Enter meta description to improve CTR..."
//               className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-xs h-28 focus:ring-1 focus:ring-amber-500 outline-none"
//               value={metaDescription}
//               onChange={(e) => setMetaDescription(e.target.value)}
//             />
            
//             <div className="mt-4 p-3 bg-amber-50 rounded-lg border border-amber-100">
//               <p className="text-[10px] text-amber-800 font-mono break-all">
//                 URL: kanthasri.com/blog/<span className="font-bold underline">{slug || '...'}</span>
//               </p>
//             </div>
//           </div>

//           <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
//             <label className="block text-[10px] font-bold text-slate-500 uppercase mb-3">Featured Image (Banner)</label>
//             <div className="relative group cursor-pointer h-40 bg-slate-100 rounded-xl border-2 border-dashed border-slate-200 overflow-hidden flex items-center justify-center transition-all hover:border-amber-400">
//               {featuredImage ? (
//                 <img src={featuredImage} alt="Banner" className="w-full h-full object-cover" />
//               ) : (
//                 <div className="text-center p-4">
//                   <FaImage className="mx-auto text-slate-300 mb-2" size={24} />
//                   <span className="text-[10px] text-slate-400 font-bold uppercase">Upload Banner</span>
//                 </div>
//               )}
//               <input type="file" className="absolute inset-0 opacity-0 cursor-pointer" onChange={handleFeaturedImageUpload} />
//             </div>
//           </div>

//           {/* Saree Keywords Tip */}
//           <div className="bg-slate-900 p-5 rounded-2xl text-white">
//             <h4 className="text-xs font-bold mb-2 flex items-center gap-2 text-amber-400">
//               <FaTag /> SEO Tip
//             </h4>
//             <p className="text-[11px] leading-relaxed text-slate-300">
//               Include keywords like <b>"Authentic Kantha,"</b> <b>"Shantiniketan,"</b> and <b>"Hand-stitched"</b> in the first 100 words to improve your Birbhum saree rankings.
//             </p>
//           </div>
//         </aside>
//       </div>
//     </div>
//   );
// };

// export default BlogEditor;
import React, { useState, useEffect } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Image from '@tiptap/extension-image';
import uploadImage from '../helper/uploadImage'; 
import apiCall from '../helper/apiCall';
import { 
  FaBold, FaItalic, FaListUl, FaHeading, 
  FaImage, FaSave, FaSpinner, FaUser, FaTag, FaGlobe 
} from 'react-icons/fa';

// --- TOOLBAR COMPONENT ---
const MenuBar = ({ editor }) => {
  const [isUploading, setIsUploading] = useState(false);

  if (!editor) return null;

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setIsUploading(true);
    try {
      const data = await uploadImage(file);
      if (data?.secure_url) {
        editor.chain().focus().setImage({ 
          src: data.secure_url, 
          alt: 'Authentic Hand-stitched Kantha Saree - kanthasri.com' 
        }).run();
      }
    } catch (error) {
      alert("Image upload failed");
    } finally {
      setIsUploading(false);
      event.target.value = '';
    }
  };

  return (
    <div className="flex flex-wrap gap-2 p-3 border-b border-slate-100 bg-slate-50 rounded-t-2xl sticky top-0 z-20">
      <button 
        type="button"
        onClick={() => editor.chain().focus().toggleBold().run()}
        className={`p-2 rounded transition ${editor.isActive('bold') ? 'bg-indigo-100 text-indigo-600' : 'hover:bg-slate-200'}`}
      >
        <FaBold />
      </button>
      <button 
        type="button"
        onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
        className={`p-2 rounded transition ${editor.isActive('heading', { level: 2 }) ? 'bg-indigo-100 text-indigo-600' : 'hover:bg-slate-200'}`}
      >
        <FaHeading />
      </button>
      <button 
        type="button"
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        className={`p-2 rounded transition ${editor.isActive('bulletList') ? 'bg-indigo-100 text-indigo-600' : 'hover:bg-slate-200'}`}
      >
        <FaListUl />
      </button>

      <div className="w-[1px] h-6 bg-slate-300 mx-1 self-center" />

      <label className="relative p-2 text-slate-600 hover:bg-slate-200 rounded cursor-pointer flex items-center gap-2 transition">
        {isUploading ? <FaSpinner className="animate-spin text-indigo-600" /> : <FaImage />}
        <span className="text-xs font-bold uppercase tracking-tighter">
          {isUploading ? 'Uploading...' : 'In-Post Image'}
        </span>
        <input type="file" className="hidden" accept="image/*" disabled={isUploading} onChange={handleFileChange} />
      </label>
    </div>
  );
};

// --- MAIN EDITOR COMPONENT ---
const BlogEditor = () => {
  const [title, setTitle] = useState('');
  const [slug, setSlug] = useState('');
  const [category, setCategory] = useState('Kantha Heritage');
  const [metaDescription, setMetaDescription] = useState('');
  const [featuredImage, setFeaturedImage] = useState('');
  const [authorName, setAuthorName] = useState('Kanthasri Team');
  const [isPublishing, setIsPublishing] = useState(false);

  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        heading: { levels: [2, 3] }
      }),
      Image.configure({
        HTMLAttributes: { 
          class: 'rounded-2xl shadow-xl my-10 max-w-full border border-slate-100 mx-auto block' 
        },
      }),
    ],
    content: '',
    editorProps: {
      attributes: { 
        class: 'prose prose-stone prose-lg focus:outline-none max-w-none min-h-[600px] p-10 bg-white' 
      },
      // PREVENT DOUBLE ENCODING: This ensures pasted HTML stays as HTML
      transformPastedHTML(html) {
        return html; 
      }
    },
  });

  const handleTitleChange = (e) => {
    const val = e.target.value;
    setTitle(val);
    // SEO Friendly Slug Generation
    setSlug(val.toLowerCase().trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '')
    );
  };

  const handleFeaturedImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const data = await uploadImage(file);
      setFeaturedImage(data.secure_url);
    }
  };

  const publishBlog = async () => {
    if (!title || !editor.getHTML()) return alert("Please add a title and content.");
    
    setIsPublishing(true);
    const blogData = {
      title,
      slug,
      content: editor.getHTML(), // Raw HTML for Postgres
      meta_description: metaDescription,
      featured_image_url: featuredImage,
      category,
      author_name: authorName,
      is_published: true
    };

    try {
      const result = await apiCall('saveBlog', blogData); 
      if (result.success) {
        alert("Published! Your story is now driving traffic to kanthasri.com");
      } else {
        alert(result.message || "Failed to save.");
      }
    } catch (error) {
      console.error("Publishing Error:", error);
    } finally {
      setIsPublishing(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f8f9fa] p-4 md:p-10 font-sans">
      {/* Header Branding */}
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center mb-10 bg-white p-6 rounded-3xl shadow-sm border border-slate-100 gap-4">
        <div className="flex items-center gap-4">
          <div className="bg-amber-900 w-12 h-12 rounded-2xl flex items-center justify-center text-white text-xl shadow-lg shadow-amber-200">
            <FaGlobe />
          </div>
          <div>
            <h1 className="text-2xl font-black text-slate-800 tracking-tight">kanthasri.com</h1>
            <p className="text-[10px] font-bold text-amber-600 uppercase tracking-[0.2em]">SEO Content Studio</p>
          </div>
        </div>
        
        <button 
          onClick={publishBlog}
          disabled={isPublishing}
          className="w-full md:w-auto flex items-center justify-center gap-3 px-12 py-4 bg-amber-900 text-white font-bold rounded-2xl hover:bg-black transition-all hover:scale-[1.02] active:scale-95 disabled:bg-slate-300 shadow-xl"
        >
          {isPublishing ? <FaSpinner className="animate-spin" /> : <FaSave />} 
          <span>Publish Story</span>
        </button>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-4 gap-10">
        {/* Main Editor */}
        <div className="lg:col-span-3 space-y-8">
          <div className="bg-white rounded-[2.5rem] shadow-xl shadow-slate-200/50 border border-slate-100 overflow-hidden">
            <input 
              type="text"
              placeholder="Article Headline..."
              className="w-full text-5xl font-serif p-12 pb-6 outline-none border-none text-slate-900 placeholder:text-slate-100 leading-tight"
              value={title}
              onChange={handleTitleChange}
            />
            <MenuBar editor={editor} />
            <EditorContent editor={editor} />
          </div>
        </div>

        {/* Sidebar Controls */}
        <aside className="space-y-8">
          {/* SEO ENGINE CARD */}
          <div className="bg-white p-8 rounded-3xl shadow-sm border border-slate-200">
            <h3 className="text-[11px] font-black text-slate-400 uppercase tracking-widest mb-6 flex items-center gap-2">
              <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span> Google SEO Engine
            </h3>
            
            <div className="space-y-5">
              <div>
                <div className="flex justify-between mb-2">
                  <label className="text-[11px] font-bold text-slate-600 uppercase">Meta Description</label>
                  <span className={`text-[10px] font-bold ${metaDescription.length > 155 ? 'text-red-500' : 'text-slate-400'}`}>
                    {metaDescription.length}/160
                  </span>
                </div>
                <textarea 
                  placeholder="Summarize the saree's story for Google..."
                  className="w-full p-4 bg-slate-50 border border-slate-200 rounded-2xl text-sm h-32 focus:ring-2 focus:ring-amber-200 outline-none transition-all resize-none"
                  value={metaDescription}
                  onChange={(e) => setMetaDescription(e.target.value)}
                />
              </div>

              <div className="p-4 bg-indigo-50 rounded-2xl border border-indigo-100">
                <p className="text-[10px] text-indigo-700 font-mono leading-relaxed truncate">
                  <span className="opacity-50 text-indigo-900 font-bold italic">URL:</span> kanthasri.com/blog/{slug || '...'}
                </p>
              </div>
            </div>
          </div>

          {/* FEATURED IMAGE CARD */}
          <div className="bg-white p-8 rounded-3xl shadow-sm border border-slate-200">
            <label className="block text-[11px] font-bold text-slate-600 uppercase mb-4 text-center">Featured Saree Banner</label>
            <div className="relative group cursor-pointer h-48 bg-slate-50 rounded-2xl border-2 border-dashed border-slate-200 overflow-hidden flex items-center justify-center transition-all hover:bg-white hover:border-amber-500">
              {featuredImage ? (
                <img src={featuredImage} alt="Banner Preview" className="w-full h-full object-cover" />
              ) : (
                <div className="text-center p-6">
                  <FaImage className="mx-auto text-slate-300 mb-3" size={32} />
                  <span className="text-[10px] text-slate-400 font-bold uppercase tracking-widest">Click to Upload</span>
                </div>
              )}
              <input type="file" className="absolute inset-0 opacity-0 cursor-pointer" onChange={handleFeaturedImageUpload} />
            </div>
          </div>

          {/* TIPS SECTION */}
          <div className="bg-amber-900 p-6 rounded-3xl text-white shadow-lg shadow-amber-900/20">
            <h4 className="text-sm font-bold mb-3 flex items-center gap-2 text-amber-300">
              <FaTag /> Organic Traffic Tip
            </h4>
            <p className="text-xs leading-relaxed text-amber-50/70 italic">
              "Mentioning Shantiniketan and Birbhum in your first paragraph increases your chances of appearing in local craft searches."
            </p>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default BlogEditor;